export enum ReferralStatus {
  Created = 'CREATED',
  NotQualified = 'NOT_QUALIFIED',
  Qualified = 'QUALIFIED',
  Paid = 'PAID',
  Ended = 'ENDED',
}

export enum ReferralEligibility {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
}

export enum ReferralIneligibilityReason {
  CurrentCustomer = 'CURRENT_CUSTOMER',
  RecentSalesContact = 'RECENT_SALES_CONTACT',
  Duplicate = 'DUPLICATE',
  SelfReferral = 'SELF_REFERRAL',
  UnknownReferrer = 'UNKNOWN_REFERRER',
}

export enum ReferralPath {
  GiftCard = 'GIFT_CARD',
  Position = 'POSITION',
}

export enum ReferralSource {
  Link = 'LINK',
  EmailIntro = 'EMAIL_INTRO',
}

export enum ReferralRewardStatus {
  AwaitingPath = 'AWAITING_PATH',
  Processing = 'PROCESSING',
  Sent = 'SENT',
  DeliveryFailed = 'DELIVERY_FAILED',
  PositionGranted = 'POSITION_GRANTED',
  Canceled = 'CANCELED',
}

export enum ReferralRewardFallbackReason {
  NoCap = 'NO_CAP',
  ReferrerGone = 'REFERRER_GONE',
}

export enum ReferralPositionEndReason {
  TermElapsed = 'TERM_ELAPSED',
  ReferredStoppedPaying = 'REFERRED_STOPPED_PAYING',
  Manual = 'MANUAL',
}

export enum ReferralForceSendOutcome {
  Sent = 'SENT',
  HeldDisabled = 'HELD_DISABLED',
  HeldNotConfigured = 'HELD_NOT_CONFIGURED',
  HeldBreaker = 'HELD_BREAKER',
  Failed = 'FAILED',
  // The reward is no longer a PROCESSING gift card (already sent, or changed since the page loaded).
  NotIssuable = 'NOT_ISSUABLE',
}

export enum ReferralRowAction {
  OverrideEligibility = 'OVERRIDE_ELIGIBILITY',
  RecheckEligibility = 'RECHECK_ELIGIBILITY',
  LinkAccount = 'LINK_ACCOUNT',
  UnlinkAccount = 'UNLINK_ACCOUNT',
  TogglePayingOutsideStripe = 'TOGGLE_PAYING_OUTSIDE_STRIPE',
  Qualify = 'QUALIFY',
  ResendReward = 'RESEND_REWARD',
  ForceSendReward = 'FORCE_SEND_REWARD',
  EndPosition = 'END_POSITION',
}
